import memoizeOne from 'memoize-one';
import {
	EDIT,
	COPY,
	DELETE,
	CHANGE_OWNER,
} from '@atlassian/jira-directory-base/src/model/operation-types.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { EntityCellProps } from '../../../../model/index.tsx';
import { openCopyFilterModal } from '../../../../state/actions/copy-filter-modal/index.tsx';
import { getAtlassianAccountId, getIsAdmin } from '../../../../state/selectors/app/index.tsx';
import { isCopyFilterModalOpen } from '../../../../state/selectors/copy-filter-modal/index.tsx';
import {
	manageSubscriptionsUrl,
	getOwner,
	getName,
	getIsWritable,
} from '../../../../state/selectors/filters/index.tsx';
import type { State } from '../../../../state/types.tsx';
import ActionsOld from './view-old.tsx';

const mapStateToPropsFactory = () => {
	const onCopyFactory = memoizeOne(
		(onOperationRequested: EntityCellProps['onOperationRequested']) => () =>
			// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
			onOperationRequested(COPY),
	);
	const onEditFactory = memoizeOne(
		(onOperationRequested: EntityCellProps['onOperationRequested']) => () =>
			// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
			onOperationRequested(EDIT),
	);
	const onChangeOwnerFactory = memoizeOne(
		(onOperationRequested: EntityCellProps['onOperationRequested']) => () =>
			// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
			onOperationRequested(CHANGE_OWNER),
	);
	const onDeleteFactory = memoizeOne(
		(onOperationRequested: EntityCellProps['onOperationRequested']) => () =>
			// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
			onOperationRequested(DELETE),
	);
	return (state: State, ownProps: EntityCellProps) => ({
		onCopy: onCopyFactory(ownProps.onOperationRequested),
		onEdit: onEditFactory(ownProps.onOperationRequested),
		onChangeOwner: onChangeOwnerFactory(ownProps.onOperationRequested),
		onDelete: onDeleteFactory(ownProps.onOperationRequested),
		manageSubscriptionsUrl: manageSubscriptionsUrl(state, ownProps.id),
		name: getName(state, ownProps.id),
		owner: getOwner(state, ownProps.id),
		atlassianAccountId: getAtlassianAccountId(state),
		showSpinner: ownProps.isOperationInProgress,
		isCopyFilterModalOpen: isCopyFilterModalOpen(state),
		isWritable: getIsWritable(state, ownProps.id),
		isAdmin: getIsAdmin(state),
		filterId: ownProps.id,
	});
};

const mapDispatchToProps = {
	onOpenCopyFilterModal: openCopyFilterModal,
} as const;

export default connect(mapStateToPropsFactory, mapDispatchToProps)(ActionsOld);
